<template>
  <div class="astrologylogin astrology-auth-container">
    <div class="h-100">
      <div class="row h-100 m-0 authRowContainer">
        <div
          class="
            col-xl-5 col-lg-5 col-md-6 col-sm-12
            my-md-auto my-1
            order-2 order-md-1
          "
        >
          <Login
            titleH2="Welcome"
            guard="AV"
             logoSrc="astrology/av-logo-auth.png"
            clientLink="astrology_ventures"
          />
        </div>
        <!-- <div
          class="
            col-xl-7 col-lg-7 col-md-6 col-sm-12
            my-md-auto my-1
            order-1 order-md-2
          "
          id="astrologyImdColDiv"
        >
          <div class="container text-center" id="astrologyImdDiv">
            <img
              class="img-fluid mx-auto"
              id="astrologyLoginImg"
              src="@/assets/images/astrology/astrology-login-image2.png"
              alt="astrology Logo"
            />
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import Login from "@/components/auth/Login";

export default {
  name: "AstrologyLogin",
  components: { Login },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    onSubmit() {
      console.log("submit login");
    },
  },
};
</script>
<style  scoped::v-deep>
@import "../css/astrology-auth-styles.css";
</style>



// WEBPACK FOOTER //
// src/components/astrology_ventures/auth/LoginView.vue